// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Navbar from '../components/Navbars/Navbar';
// import axios from 'axios';
// import { useTranslation } from 'react-i18next';
// import SideBar4 from '../components/Sidebar/SideBar4';
// import { Form, Select, Input, Card, Pagination } from 'antd';
// import useFetchCauses from '../hooks/fetchCauses';
// import getCauseByOrg from '../hooks/getCauseByOrg';
// import getEventsByOrg from '../hooks/getEventsByOrg';
// import OrgNav from '../components/Navbars/OrgNav';
// import useFetchEventsList from '../hooks/fetchEventsList';
// import { EditTwoTone } from '@ant-design/icons';
// import { app } from '../config';
// import NewSideBar from '../components/Sidebar/NewSideBar';
// import { dateConverter } from '../utils/utcDateConversion';
// import { getTokenfromUserObj } from '../utils/getTokenfromObj';
// import useFetchOrganizations from '../hooks/fetchOrganizations';
// import NoRecordFound from '../components/common/NoRecordFound';

// const Events = () => {
//   const { t } = useTranslation(['common']);
//   const { Search } = Input;
//   const [form] = Form.useForm();
//   const [events, setEvents] = useState([]);
//   const [renderList, setRenderList] = useState([]);
//   const [current, setCurrent] = useState(1);
//   const [commonData, setCommonData] = useState([]);
//   const [pagesCount, setPagesCount] = useState(0);
//   const [orgdata, setOrgData] = useState();
//   const [searchValue, setSearchValue] = useState('');
//   const [pageObj, setPageObj] = useState({});
//   const [clearSearch, setClearSearch] = useState(false);
//   // const [searchClear,setSearchClear]=useState(document.getElementById('search').value)
//   let navigate = useNavigate();
//   let user = JSON.parse(localStorage.getItem('user'));
//   console.log(user);
//   const token = getTokenfromUserObj();
//   const e = useFetchEventsList();
//   console.log(e);
//   const orgResp = useFetchOrganizations();
//   console.log(orgResp);
//   let orgObj = orgResp.response ? orgResp.response.data : [];
//   // const handleClearClick = () => {
//   //   console.log('Clear search called');
//   //   form.setFieldsValue({ ['organizationId']: "" });
//   //   // setOrgData("");
//   //   // setOrgData();
//   //   // // form.resetFields();
//   //   // console.log(document.getElementById('search').value);
//   //   // document.getElementById('search').value = null;
//   //   // document.getElementById('search').innerHTML = null;
//   //   // form.setFieldsValue({ ['oranizationId']: "" });
//   //   setClearSearch(true);
    
//   // };
  
//   const handleClearClick = () => {
//     console.log('Clear search called');
//     // setOrgData();
//     form.resetFields();
//     console.log(document.getElementById('search').value);
//     document.getElementById('search').value = null;
//     document.getElementById('search').innerHTML = null;
//     setClearSearch(true);
//   };
  
  
//   useEffect(() => {
//     const fetchEvents = async () => {
//       const limit = 6;
//       const offset = 0;
//       let eventAPI;
//       if (user.userType === 'A') eventAPI = `${app.URL}/event/view`;
//       else if (user.userType === 'O') eventAPI = `${app.URL}/event/viewbyorg?orgId=${user.organizationId}`;
//       const eventResp = await axios.get(eventAPI, { headers: { auth: token } });
//       console.log(eventResp);
//       console.log(eventResp.data.data);
//       let convertedObj;
//       eventResp.data ? (convertedObj = dateConverter(eventResp.data.data, 'startDate')) : ' ';
//       convertedObj = dateConverter(convertedObj, 'endDate');
//       eventResp.data ? setEvents(convertedObj) : [];
//       eventResp.data ? setCommonData(convertedObj) : [];
//       eventResp.data ? setPagesCount(eventResp.data.data.length) : 0;
//       eventResp.data ? setRenderList(convertedObj.slice(0, 50)) : [];
//       setClearSearch(false);
//     };
//     fetchEvents();
//   }, [clearSearch]);
//   console.log('PageObj', pageObj);
//   useEffect(() => {
//     const fetchDataByOrg = async () => {
//       console.log('fetch data by org');
//       let eventAPI;
//       let dataObj = {
//         limit: 10,
//         offset: 0,
//       };
//       if (!pageObj.limit) setPageObj(dataObj);

//       if (user.userType === 'A') eventAPI = `${app.URL}/event/getbyorg/${orgdata}`;
//       const eventResp = await axios.post(eventAPI, pageObj, { headers: { auth: token } });
//       console.log(eventResp);
//       console.log(eventResp.data.data.data);
//       console.log(eventResp.data.data.count);
//       let convertedObj;
//       eventResp.data ? (convertedObj = dateConverter(eventResp.data.data.data, 'startDate')) : ' ';
//       convertedObj = dateConverter(convertedObj, 'endDate');
//       eventResp.data ? setEvents(convertedObj) : [];
//       eventResp.data ? setCommonData(convertedObj) : [];
//       eventResp.data ? setPagesCount(eventResp.data.data.count) : 0;
//       eventResp.data ? setRenderList(convertedObj) : [];
//     };
//     fetchDataByOrg();
//   }, [orgdata, pageObj]);
//   const onFinish = (values) => {
//     console.log('Success:', values);
//   };
//   const onFinishFailed = (errorInfo) => {
//     console.log('Failed:', errorInfo);
//   };
//   const onChange = async (page, pageSize) => {
//     console.log(page, pageSize);
//     setCurrent(page);
//     if (!page) page = 1;
//     let limit = pageSize;
//     let reqObj = {
//       limit,
//       offset: limit * (page - 1),
//     };
//     console.log(reqObj);
//     setPageObj(reqObj);
//     setRenderList(commonData.slice(reqObj.offset, reqObj.offset + limit));
//   };
//   const onSearch = async (value) => {
//     console.log(value);
//     try {
//       const result = await axios.post(`${app.URL}/event/search/${value}`, user, { headers: { auth: token } });
//       console.log(result.data.data);
//       let convertedObj;
//       result.data ? (convertedObj = dateConverter(result.data.data, 'startDate')) : ' ';
//       convertedObj = dateConverter(convertedObj, 'endDate');
//       result.data ? setCommonData(convertedObj) : [];
//       result.data ? setRenderList(convertedObj.slice(0, 50)) : [];
//       result.data ? setPagesCount(result.data.data.length) : 0;
//       // result.data ? setSearchValue(''):'';
//       // result.data ? form.setFieldsValue({ ['search']: "" }):'';
//     } catch (e) {
//       console.log('Error');
//       console.log(e);
//       if (e.message) setErr(e.response.data.message);
//       setTableShow(false);
//     }
//   };

//   const handleSearchChange = (e) => {
//     console.log(e.target.value);
//     e.target.value ?setSearchValue(e.target.value) :"";
//     if (!e.target.value) {
//       setRenderList(events.slice(0, 10));
//       setCommonData(events);
//       setPagesCount(events.length);
//     }
//   };

//   const addEvent = (e) => {
//     console.log(e);
//     if (user.userType === 'A') navigate('/event/add', { replace: true });
//     else if (user.userType === 'O') navigate('/events/add', { replace: true });
//   };
//   const editEvents = (e) => {
//     console.log(e);
//     localStorage.setItem('eventId', JSON.stringify(e.eventsId));
//     if (user.userType === 'A') navigate('/event/edit', { replace: true });
//     else if (user.userType === 'O') navigate('/events/edit', { replace: true });
//   };
//   const selectOrgId = (e) => {
//     console.log('Select org Id');
//     setOrgData(e);
//   };

//   let orgSelectorStyle=orgdata?'col-lg-3 eventselect':'col-lg-4 eventselect';

//   return (
//     <div className='ml-3 col-lg-12 col-md-12 col-sm-12'>
//       <div className='row'>
//         <div className='col-lg-8 col-md-8 col-sm-12 '>
//           <div class='mt-4 fs-3 fw-bold'> {t('Events Management')} </div>
//         </div>

//        {user.userType==="A"?
//         <Form
//           name='basic'
//           form={form}
//           initialValues={{
//             remember: true,
//           }}
//           onFinish={onFinish}
//           onFinishFailed={onFinishFailed}
//           autoComplete='off'
//         >
//           <div className='row text-left mt-4 mt-2'>
//           <div className='col-lg-3 eventselect'>
//           <Form.Item
//                   form={form}
//                   colon={false}
//                   name='organizationId'
//                   rules={[
//                     {
//                       required: false,
//                       message: 'Select Organization',
//                     },
//                   ]}
//                 >
//                   <Select
//                     className='custom-select-dropdown'
//                     listHeight={250}
//                     listItemHeight={500}
//                     onChange={selectOrgId}
//                     style={{
//                       display: 'inline-block ',
//                     }}
//                     placeholder='Select Organization'
//                   >
//                     {orgObj.map((orgs) => {
//                       return (
//                         <Option
//                         className="select-option"
//                         key={orgs.organizationId} value={orgs.organizationId}>
//                           {orgs.organizationName}
//                         </Option>
//                       );
//                     })}
//                   </Select>
//                 </Form.Item>
//           </div>
//           <div className='col-lg-2'>
//                 <button class='btn btn-primary button'
//                   // onClick={handleClearClick}
//                 >
//                     Clear
//                   </button>
//           </div>
//           <div className='col-lg-3'>
//                 <Form.Item
//                 name="search">
//                     <Search
//                       id='search'
//                       className='event-search'
//                       placeholder='Search by Title'
//                     onSearch={onSearch}
//                     // value={searchValue}
//                       onChange={handleSearchChange}
//                       style={{
//                         width: 300,
//                         height:50
//                       }}
//                     />
//                   </Form.Item>
//           </div>
//             <div className='col-lg-3 offset-lg-1 text-center col-md-4 col-sm-12'>
//               <button class='btn btn-primary button' onClick={addEvent}>
//                 Add Event
//               </button>
//             </div>
//           </div>
//         </Form> :" "}
//         {user.userType==="O"?
//            <Form
//            name='basic'
//            form={form}
//            initialValues={{
//              remember: true,
//            }}
//            onFinish={onFinish}
//            onFinishFailed={onFinishFailed}
//            autoComplete='off'
//          >
//            <div className='row text-right mt-4 mt-2'>
//            <div className='col-lg-4 eventSelect'>
    
//            </div>
//            <div className='col-lg-4'>
//            <Form.Item>
//                      <Search
//                        id='search'
//                        className='event-search'
//                        placeholder='Search by Title'
//                        onSearch={onSearch}
//                        onChange={handleSearchChange}
//                        style={{
//                          width: 300,
//                          height:50
//                        }}
//                      />
//                    </Form.Item>
//            </div>
//              <div className='col-lg-2 offset-lg-1 text-center col-md-4 col-sm-12'>
//                <button class='btn btn-primary button' onClick={addEvent}>
//                  Add Event
//                </button>
//              </div>
//            </div>
//          </Form>:" "}
//       </div>
//       <div className='col-lg-11 col-md-12 col-sm-12 '>
//         {/* <div class=' styled-table '> */}
//         <div class=' styled-table '>
//           <table class='table text-black'>
//             <thead class='thead-light'>
//               <tr>
//                 {/* <th>{t("ID")}</th> */}
//                 {user.userType === 'A' ? <th>{t('Organization')}</th> : ' '}
//                 <th>{t('Event Name')}</th>
//                 <th>{t('Speaker')}</th>
//                 <th>{t('Start Date & Time')}</th>
//                 <th>{t('End Date & Time')}</th>
//                 {/* <th>{t('Description')}</th> */}
//                 <th>{t('Status')}</th>
//                 <th> </th>
//               </tr>
//             </thead>
//             <tbody>
//               {renderList
//                 ? renderList.map((output) => (
//                     <tr
//                       onClick={() => {
//                         editEvents(output);
//                       }}
//                     >
//                       {/* <td style={{width:"100px"}}>{output.eventsId}</td> */}
//                       {/* onClick={()=>{editUser(output)}} style={{color:"blue",textDecoration:"underline", width:"160px"}} */}
//                       {user.userType === 'A' ? <td style={{ width: '200px' }}>{output.organizationName}</td> : ' '}
//                       <td style={{ width: '200px' }}>{output.eventName ? output.eventName : 'null'}</td>
//                       <td style={{ width: '170px' }}>{output.speaker}</td>
//                       <td style={{ width: '200px' }}>
//                         {output.startDate} {output.startTime}
//                       </td>
//                       <td style={{ width: '200px' }}>
//                         {output.endDate} {output.endTime}
//                       </td>
//                       {/* <td style={{ width: '200px' }}>{output.description.slice(0, 50)}</td> */}
//                       <td style={{ width: '80px' }}>{output.status}</td>
//                       <td style={{ width: '20px' }}>
//                         <EditTwoTone
//                           displayName='edit'
//                           twoToneColor='blue'
//                           style={{ fontSize: '20px' }}
//                           onClick={() => {
//                             editEvents(output);
//                           }}
//                         />
//                         {/* <button type='button' style={{ display: editbtn }} class='btn btn-primary color1 button' onClick={() => editOrg(output)}>
//                          {t('Edit')}
//                        </button> */}
//                       </td>
//                     </tr>
//                   ))
//                 : ' '}
//             </tbody>
//           </table>
//           {renderList&&renderList.length == 0?<NoRecordFound/>:" "}
//         </div>
//       </div>
//       <Pagination style={{ marginTop: '10px' }} onChange={onChange} defaultCurrent={current} pageSize={50} total={pagesCount} />
//     </div>
//     // </div>
//   );
// };

// export default Events;


import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Form, Select, Input, Card, Pagination } from 'antd';
import useFetchEventsList from '../../hooks/fetchEventsList';
import { EditTwoTone } from '@ant-design/icons';
import { app } from '../../config';
import { dateConverter } from '../../utils/utcDateConversion';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import NoRecordFound from '../../components/common/NoRecordFound';

const Events = () => {
  const { t } = useTranslation(['common']);
  const { Search } = Input;
  const [form] = Form.useForm();
  const [events, setEvents] = useState([]);
  const [renderList, setRenderList] = useState([]);
  const [current, setCurrent] = useState(1);
  const [commonData, setCommonData] = useState([]);
  const [pagesCount, setPagesCount] = useState(0);
  const [orgdata, setOrgData] = useState();
  const [searchValue, setSearchValue] = useState('');
  const [pageObj, setPageObj] = useState({});
  const [clearSearch, setClearSearch] = useState(false);
  // const [searchClear,setSearchClear]=useState(document.getElementById('search').value)
  let navigate = useNavigate();
  let user = JSON.parse(localStorage.getItem('user'));
  console.log(user);
  const token = getTokenfromUserObj();
  const e = useFetchEventsList();
  console.log(e);
  const orgResp = useFetchOrganizations();
  console.log(orgResp);
  let orgObj = orgResp.response ? orgResp.response.data : [];
  // const handleClearClick = () => {
  //   console.log('Clear search called');
  //   form.setFieldsValue({ ['organizationId']: "" });
  //   // setOrgData("");
  //   // setOrgData();
  //   // // form.resetFields();
  //   // console.log(document.getElementById('search').value);
  //   // document.getElementById('search').value = null;
  //   // document.getElementById('search').innerHTML = null;
  //   // form.setFieldsValue({ ['oranizationId']: "" });
  //   // setClearSearch(true);

  // };

  const handleClearClick = () => {
    console.log('Clear search called');
    // setOrgData();
    form.resetFields();
    console.log(document.getElementById('search').value);
    document.getElementById('search').value = null;
    document.getElementById('search').innerHTML = null;
    setClearSearch(true);
  };


  useEffect(() => {
    const fetchEvents = async () => {
      const limit = 6;
      const offset = 0;
      let eventAPI;
      if (user.userType === 'A') eventAPI = `${app.URL}/event/view`;
      else if (user.userType === 'O') eventAPI = `${app.URL}/event/viewbyorg?orgId=${user.organizationId}`;
      const eventResp = await axios.get(eventAPI, { headers: { auth: token } });
      console.log(eventResp);
      console.log(eventResp.data.data);
      let convertedObj;
      eventResp.data ? (convertedObj = dateConverter(eventResp.data.data, 'startDate')) : ' ';
      convertedObj = dateConverter(convertedObj, 'endDate');
      eventResp.data ? setEvents(convertedObj) : [];
      eventResp.data ? setCommonData(convertedObj) : [];
      eventResp.data ? setPagesCount(eventResp.data.data.length) : 0;
      eventResp.data ? setRenderList(convertedObj.slice(0, 50)) : [];
      setClearSearch(false);
    };
    fetchEvents();
  }, [clearSearch]);
  console.log('PageObj', pageObj);
  useEffect(() => {
    const fetchDataByOrg = async () => {
      console.log('fetch data by org');
      let eventAPI;
      let dataObj = {
        limit: 10,
        offset: 0,
      };
      if (!pageObj.limit) setPageObj(dataObj);

      if (user.userType === 'A') eventAPI = `${app.URL}/event/getbyorg/${orgdata}`;
      const eventResp = await axios.post(eventAPI, pageObj, { headers: { auth: token } });
      console.log(eventResp);
      console.log(eventResp.data.data.data);
      console.log(eventResp.data.data.count);
      let convertedObj;
      eventResp.data ? (convertedObj = dateConverter(eventResp.data.data.data, 'startDate')) : ' ';
      convertedObj = dateConverter(convertedObj, 'endDate');
      eventResp.data ? setEvents(convertedObj) : [];
      eventResp.data ? setCommonData(convertedObj) : [];
      eventResp.data ? setPagesCount(eventResp.data.data.count) : 0;
      eventResp.data ? setRenderList(convertedObj) : [];
    };
    fetchDataByOrg();
  }, [orgdata, pageObj]);
  const onFinish = (values) => {
    console.log('Success:', values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const onChange = async (page, pageSize) => {
    console.log(page, pageSize);
    setCurrent(page);
    if (!page) page = 1;
    let limit = pageSize;
    let reqObj = {
      limit,
      offset: limit * (page - 1),
    };
    console.log(reqObj);
    setPageObj(reqObj);
    setRenderList(commonData.slice(reqObj.offset, reqObj.offset + limit));
  };
  const onSearch = async (value) => {
    console.log(value);
    try {
      const result = await axios.post(`${app.URL}/event/search/${value}`, user, { headers: { auth: token } });
      console.log(result.data.data);
      let convertedObj;
      result.data ? (convertedObj = dateConverter(result.data.data, 'startDate')) : ' ';
      convertedObj = dateConverter(convertedObj, 'endDate');
      result.data ? setCommonData(convertedObj) : [];
      result.data ? setRenderList(convertedObj.slice(0, 50)) : [];
      result.data ? setPagesCount(result.data.data.length) : 0;
      // result.data ? setSearchValue(''):'';
      // result.data ? form.setFieldsValue({ ['search']: "" }):'';
    } catch (e) {
      console.log('Error');
      console.log(e);
      if (e.message) setErr(e.response.data.message);
      setTableShow(false);
    }
  };

  const handleSearchChange = (e) => {
    console.log(e.target.value);
    e.target.value ? setSearchValue(e.target.value) : "";
    if (!e.target.value) {
      setRenderList(events.slice(0, 10));
      setCommonData(events);
      setPagesCount(events.length);
    }
  };

  const addEvent = (e) => {
    console.log(e);
    if (user.userType === 'A') navigate('/event/add', { replace: true });
    else if (user.userType === 'O') navigate('/events/add', { replace: true });
  };
  const editEvents = (e) => {
    console.log(e);
    localStorage.setItem('eventId', JSON.stringify(e.eventsId));
    if (user.userType === 'A') navigate('/event/edit', { replace: true });
    else if (user.userType === 'O') navigate('/events/edit', { replace: true });
  };
  const selectOrgId = (e) => {
    console.log('Select org Id');
    setOrgData(e);
  };

  let orgSelectorStyle = orgdata ? 'col-lg-3 eventselect' : 'col-lg-4 eventselect';

  return (
    <div className='ml-3 col-lg-12 col-md-12 col-sm-12'>
      <div className='row'>
        <div className='col-lg-8 col-md-8 col-sm-12 '>
          <div class='mt-4 fs-3 fw-bold'> {t('Events Management')} </div>
        </div>

        {user.userType === "A" ?
          <Form
            name='basic'
            form={form}
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete='off'
          >
            <div className='row text-left mt-4 mt-2'>
              <div className='col-lg-3 eventselect'>
                <Form.Item
                  form={form}
                  colon={false}
                  name='organizationId'
                  rules={[
                    {
                      required: false,
                      message: 'Select Organization',
                    },
                  ]}
                >
                  <Select
                    className='custom-select-dropdown'
                    listHeight={250}
                    listItemHeight={500}
                    onChange={selectOrgId}
                    style={{
                      display: 'inline-block ',
                    }}
                    placeholder='Select Organization'
                  >
                    {orgObj.map((orgs) => {
                      return (
                        <Option
                          className="select-option"
                          key={orgs.organizationId} value={orgs.organizationId}>
                          {orgs.organizationName}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </div>
              <div className='col-lg-2'>
                <button class='btn btn-primary button'
                onClick={handleClearClick}
                >
                  Clear
                </button>
              </div>
              <div className='col-lg-3'>

                <Form.Item name="search">
                  <Search
                    id="search"
                    className="event-search"
                    placeholder="Search by Title"
                    onSearch={onSearch}  // Handles search when clicking the search button
                    onChange={handleSearchChange}  // Updates the search value as you type
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();  // Prevents the form from submitting on Enter key press
                        onSearch(e.target.value);  // Calls the search function directly
                      }
                    }}
                    style={{
                      width: 300,
                      height: 50,
                    }}
                  />
                </Form.Item>



                {/* <Form.Item
                  name="search">
                  <Search
                    id='search'
                    className='event-search'
                    placeholder='Search by Title'
                    onSearch={onSearch}
                    // value={searchValue}
                    onChange={handleSearchChange}
                    style={{
                      width: 300,
                      height: 50
                    }}
                  />
                </Form.Item> */}
              </div>
              <div className='col-lg-3 offset-lg-1 text-center col-md-4 col-sm-12'>
                <button class='btn btn-primary button' onClick={addEvent}>
                  Add Event
                </button>
              </div>
            </div>
          </Form> : " "}
        {user.userType === "O" ?
          <Form
            name='basic'
            form={form}
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete='off'
          >
            <div className='row text-right mt-4 mt-2'>
              <div className='col-lg-4 eventSelect'>

              </div>
              <div className='col-lg-4'>
                <Form.Item>
                  <Search
                    id='search'
                    className='event-search'
                    placeholder='Search by Title'
                    onSearch={onSearch}
                    onChange={handleSearchChange}
                    style={{
                      width: 300,
                      height: 50
                    }}
                  />
                </Form.Item>
              </div>
              <div className='col-lg-2 offset-lg-1 text-center col-md-4 col-sm-12'>
                <button class='btn btn-primary button' onClick={addEvent}>
                  Add Event
                </button>
              </div>
            </div>
          </Form> : " "}
      </div>
      <div className='col-lg-11 col-md-12 col-sm-12 '>
        {/* <div class=' styled-table '> */}
        <div class=' styled-table '>
          <table class='table text-black'>
            <thead class='thead-light'>
              <tr>
                {/* <th>{t("ID")}</th> */}
                {user.userType === 'A' ? <th>{t('Organization')}</th> : ' '}
                <th>{t('Event Name')}</th>
                <th>{t('Speaker')}</th>
                <th>{t('Start Date & Time')}</th>
                <th>{t('End Date & Time')}</th>
                {/* <th>{t('Description')}</th> */}
                <th>{t('Status')}</th>
                <th> </th>
              </tr>
            </thead>
            <tbody>
              {renderList
                ? renderList.map((output) => (
                  <tr
                    onClick={() => {
                      editEvents(output);
                    }}
                  >
                    {/* <td style={{width:"100px"}}>{output.eventsId}</td> */}
                    {/* onClick={()=>{editUser(output)}} style={{color:"blue",textDecoration:"underline", width:"160px"}} */}
                    {user.userType === 'A' ? <td style={{ width: '200px' }}>{output.organizationName}</td> : ' '}
                    <td style={{ width: '200px' }}>{output.eventName ? output.eventName : 'null'}</td>
                    <td style={{ width: '170px' }}>{output.speaker ? output.speaker : '-'}</td>
                    <td style={{ width: '200px' }}>
                      {output.startDate} {output.startTime}
                    </td>
                    <td style={{ width: '200px' }}>
                      {output.endDate} {output.endTime}
                    </td>
                    {/* <td style={{ width: '200px' }}>{output.description.slice(0, 50)}</td> */}
                    <td style={{ width: '80px' }}>{output.status}</td>
                    <td style={{ width: '20px' }}>
                      <EditTwoTone
                        displayName='edit'
                        twoToneColor='blue'
                        style={{ fontSize: '20px' }}
                        onClick={() => {
                          editEvents(output);
                        }}
                      />
                      {/* <button type='button' style={{ display: editbtn }} class='btn btn-primary color1 button' onClick={() => editOrg(output)}>
                         {t('Edit')}
                       </button> */}
                    </td>
                  </tr>
                ))
                : ' '}
            </tbody>
          </table>
          {renderList && renderList.length == 0 ? <NoRecordFound /> : " "}
        </div>
      </div>
      <Pagination style={{ marginTop: '10px' }} onChange={onChange} defaultCurrent={current} pageSize={50} total={pagesCount} />
    </div>
    // </div>
  );
};

export default Events;




